import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTER_TOKENS } from '../../app.routes';
// Directive
import { ProdHiddenElementDirective } from '../../core/directive/prod-hidden-element.directive';
// PrimeNG
import { ButtonModule } from 'primeng/button';
import { TranslocoModule } from '@jsverse/transloco';
import { LanguageConfigComponent } from '../../pattern/language-config/language-config.component';

@Component({
  selector: 'app-missing-permission-page',
  imports: [ProdHiddenElementDirective, ButtonModule, TranslocoModule, LanguageConfigComponent],
  templateUrl: './missing-permission-page.component.html',
  styleUrl: './missing-permission-page.component.scss',
})
export class MissingPermissionPageComponent {
  router = inject(Router);

  routeToApp() {
    this.router.navigateByUrl(ROUTER_TOKENS.APP);
  }
}
